<template>
  <div>
    <fieldset class="border p-3">
      <legend>
        <small style="font-size:15px; font-weight: bold">modules</small>
      </legend>
      <div>
        <form @submit.prevent="newModule()">
          <div class="form-group">
            <label>module name</label>
            <input type="text" class="form-control modulename" placeholder="module name" required />
          </div>
          
          <button type="submit" class="btn btn-primary btn-flat creatingModule">
            <i class="fa fa-plus"></i> create module
          </button>
          <button type="button" class="btn btn-info btn-flat creatingModuleLoader">
            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            <i class="fa fa-spinner fa-spin" style="font-size:24px"></i> please wait...
          </button>
        </form>
      </div>
    </fieldset>
  </div>
</template>
<script>
import { mapActions } from "vuex";

export default {
  methods: {
    ...mapActions(["newModule"])
  }
};
</script>
<style scoped>
.creatingModuleLoader {
  display: none;
}
</style>


// WEBPACK FOOTER //
// src/modules/module.vue